<template>
  <VContainer class="py-0" fluid>
    <slot />
  </VContainer>
</template>

<script setup lang="ts">
import { VContainer } from 'vuetify/components/VGrid';
</script>
